import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface FabContext {
  entityType: string;
  entityId: string;
  entityDisplayName?: string;
}

@Injectable({ providedIn: 'root' })
export class FabService {
  private contextSubject = new BehaviorSubject<FabContext | null>(null);
  readonly context$ = this.contextSubject.asObservable();

  setContext(context: FabContext): void {
    this.contextSubject.next(context);
  }

  clearContext(): void {
    this.contextSubject.next(null);
  }
}
